<template>
  <div class="commodity-brand">
    <second-menu-link-content>
      <template v-slot:header>
        <span>品牌管理</span>
      </template>
      <template v-slot:content>
        <div class="commodity-brand-main">
          <div class="search-add">
            <div class="add">
              <el-button class="btn-blue" @click="openDialog()">新增品牌</el-button>
            </div>
            <div class="search">
              <span class="tit">品牌筛选：</span>
              <el-input
                clearable
                class="white"
                v-model="content"
                @keyup.enter.native="screen"
                placeholder="请输入品牌名称/编号"
              ></el-input>
              <el-button class="btn-blue" @click="screen">筛选</el-button>
            </div>
          </div>
          <div class="table">
            <el-table :data="tableData">
              <el-table-column prop="name" label="品牌名称"></el-table-column>
              <el-table-column prop="code" label="品牌编号"></el-table-column>
              <el-table-column prop="weight" label="排序值"></el-table-column>
              <el-table-column prop="operation" label="操作">
                <template slot-scope="scope">
                  <el-button class="btn-text" type="text" @click="update(scope.row)">编辑</el-button>
                  <el-button class="btn-text" type="text" @click="remove(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="page">
              <pagination-tpl
                :pageSize="pageSize"
                :total="total"
                :currentPage="page"
                @queryChange="updatePage"
              ></pagination-tpl>
            </div>
          </div>
          <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" top="25vh">
            <!-- 黑色的线条 -->
            <div class="border"></div>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="品牌名称：" prop="name">
                <el-input v-model="ruleForm.name" class="gray" placeholder="请输入品牌名称"></el-input>
              </el-form-item>
              <el-form-item label="品牌编码：" prop="code">
                <el-input v-model="ruleForm.code" class="gray" placeholder="请输入品牌编码"></el-input>
              </el-form-item>
              <el-form-item label="排序值：" prop="weight">
                <el-input v-model.number="ruleForm.weight" class="gray" placeholder="请输入输排序值"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button class="btn-white" type="primary" @click="reset('ruleForm')">取消</el-button>
                <el-button class="btn-blue" @click="addDrand('ruleForm')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import DBCommodity from "models/db/commodity.js";
const dbCommodity = new DBCommodity();
export default {
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  },
  data() {
    return {
      content: "",
      searchContent: "",
      ruleForm: {
        name: "",
        code: "",
        weight: ""
      },
      rules: {
        name: [{ required: true, message: "请品牌名称", trigger: "blur" }],
        // code: [{ required: true, message: "请品牌编码", trigger: "blur" }],
        weight: [
          { required: true, message: "请输排序值", trigger: "blur" },
          { type: "number", message: "必须为0-100数字", min: 0, max: 100 }
        ]
      },
      tableData: [
        // {
        //   id: 12,
        //   name: '小米',
        //   code: '123456',
        //   weight: 20
        // }
      ],
      title: "",
      dialogVisible: false,
      page: 1,
      pageSize: 20,
      total: 0
    };
  },
  created() {
    this.getBrandData();
  },
  methods: {
    // 获取当前数据
    getBrandData() {
      let currentPage = this.page;
      let content = this.searchContent;
      dbCommodity.getCommodityBrand(currentPage, content).then(res => {
        if (res.success) {
          this.pageSize = res.result.pageSize;
          this.total = res.result.totalNum;
          let arr = [];
          res.result.items.map((value, index, array) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.code = value.code;
            obj.weight = value.weight;
            arr.push(obj);
          });
          this.tableData = arr;
        }
      });
    },
    // 筛选
    screen() {
      this.searchContent = this.content;
      this.getBrandData();
    },
    // 新增品牌显示弹框
    openDialog() {
      this.title = "新增品牌";
      this.dialogVisible = true;
      this.ruleForm = {
        name: "",
        code: "",
        weight: ""
      };
    },
    // 取消
    reset(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    // 保存
    addDrand(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.ruleForm.id) {
            let id = this.ruleForm.id;
            let name = this.ruleForm.name;
            let code = this.ruleForm.code;
            let weight = this.ruleForm.weight;
            let data = {
              id,
              name,
              code,
              weight
            };
            dbCommodity.getCommodityUpdateBrand(data).then(res => {
              if (res.success) {
                this.getBrandData();
                this.dialogVisible = false;
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let name = this.ruleForm.name;
            let code = this.ruleForm.code;
            let weight = this.ruleForm.weight;
            let data = {
              name,
              code,
              weight
            };
            dbCommodity.postCommodityAddBrand(data).then(res => {
              if (res.success) {
                this.getBrandData();
                this.dialogVisible = false;
                this.$message.success("添加成功");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑
    update(row) {
      this.title = "修改品牌";
      this.dialogVisible = true;
      this.ruleForm = JSON.parse(JSON.stringify(row));
    },
    remove(row) {
      this.$confirm(`是否确认删除该品牌`, "删除品牌", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = row.id;
        dbCommodity.getCommodityDeleteBrand(id).then(res => {
          if (res.success) {
            this.getBrandData();
            this.$message.success("删除成功");
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 跳转页码
    updatePage(data) {
      this.page = data.currentPage;
      this.getBrandData();
    }
  }
};
</script>

<style lang="scss" scoped>
.commodity-brand {
  width: 100%;
  height: 100%;
  .commodity-brand-main {
    .search-add {
      margin-bottom: 16px;
      .add {
        margin-bottom: 16px;
      }
      .search {
        background: #f5f7fa;
        border-radius: 4px;
        padding: 16px 0;
        display: flex;
        justify-content: flex-start;
        .tit {
          width: 100px;
          font-size: 14px;
          line-height: 32px;
          text-align: right;
        }
        .el-input {
          width: 280px;
        }
        .el-button {
          margin-left: 16px;
        }
      }
    }
    .page {
      height: 56px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .el-pagination {
        height: 28px;
        padding: 0px;
        display: flex;
      }
    }
  }
}
</style>
